import { useQuery } from "react-query";
import { SharedLessonApi } from "@api/SharedLessonApi";

export const useSharedLesson = (lessonId: string) => {
  return useQuery(["shared-lesson", lessonId], () =>
    SharedLessonApi.fetchById(lessonId),
  );
};
